import { render } from "./DocManager.vue?vue&type=template&id=53606f56"
import script from "./DocManager.vue?vue&type=script&lang=js"
export * from "./DocManager.vue?vue&type=script&lang=js"

import "./DocManager.vue?vue&type=style&index=0&id=53606f56&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__